// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__HeG_z","title":"styles_title__1BEw9"};
module.exports.__checksum = "0c4af513d6e9"
